import { render, staticRenderFns } from "./EditFrameModal.vue?vue&type=template&id=5fbfe429&scoped=true&"
import script from "./EditFrameModal.vue?vue&type=script&lang=js&"
export * from "./EditFrameModal.vue?vue&type=script&lang=js&"
import style0 from "./EditFrameModal.vue?vue&type=style&index=0&id=5fbfe429&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fbfe429",
  null
  
)

export default component.exports